import { useMutation } from "@tanstack/react-query";
import { App } from "antd";
import { Form, Formik, FormikValues } from "formik";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import { ReactComponent as Info } from "../../assets/info.svg";
import Button from "../../custom/button/button";
import Input from "../../custom/input/input";
import { changeFirstTimePassword } from "../../requests";
import { routes } from "../../routes";
import { userAtom } from "../../utils/store";
import { validator } from "../../utils/validator";

const ChangePassword = () => {
  const navigate = useNavigate();
  const { notification } = App.useApp();
  const [user, setUser] = useAtom(userAtom);

  const changePasswordMutation = useMutation({
    mutationKey: ["change-first-time-password"],
    mutationFn: changeFirstTimePassword,
  });

  const handleChangePassword = async (values: FormikValues) => {
    const payload: ChangePasswordPayload = {
      email: user?.email ?? "",
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    };

    try {
      const data = await changePasswordMutation.mutateAsync(payload);
      notification.success({ message: "Success", description: data?.message });
      setUser(undefined);
      navigate(routes.auth.login);
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  const validationSchema = Yup.object().shape({
    currentPassword: validator.password,
    newPassword: validator.newPassword,
    confirmPassword: validator.confirmPassword,
  });

  return (
    <div>
      <h4 className="text-center">Change Password</h4>
      <small className="text-center">
        Please set a new password to continue.
      </small>
      <br />
      <Formik
        initialValues={{
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        }}
        onSubmit={(values) => {
          handleChangePassword(values);
        }}
        validationSchema={validationSchema}>
        {() => {
          return (
            <Form className="fields">
              <Input
                name="currentPassword"
                type="password"
                label="Current Password"
                placeholder="Input current password"
              />
              <Input
                name="newPassword"
                type="password"
                label="New Password"
                placeholder="Input new password"
              />
              <Input
                name="confirmPassword"
                type="password"
                label="Confirm Password"
                placeholder="Confirm new password"
              />
              <small className="flex-start">
                <span>
                  <Info />
                </span>
                Password must be more than 8 characters. Must contain <br />{" "}
                uppercase, lowercase and numbers.
              </small>
              <Button
                type="submit"
                text="Change Password"
                disabled={changePasswordMutation?.isPending}
                isLoading={changePasswordMutation?.isPending}
              />
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default ChangePassword;
